import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as applicationActions from '../../stateManagement/actions/containers/application';
import * as commonTypes from '../types';

@Injectable()
export class PopNotificationService {

  constructor(private store: Store<IApplicationState>) { }

  popNotification(notificationMessage: commonTypes.IToastr) {
    this.store.dispatch(new applicationActions.PopNotificationAction(notificationMessage));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/pop-notification.service.ts